import React, { useEffect, useRef, useState } from "react";
import styles from './passwordProtected.module.css';
import { useLocation } from "react-router-dom";
import Button from "../../../Elements/Button";
import { csrfToken } from "../../../../utis/csrfTokenUtils";
import ToastNotification from "../../../CommonComponents/Toasts/ToastNotification";

const PasswordProtectedKDF = ({ alert }) => {
    const { pathname } = useLocation();
    const [showToast, setShowToast] = useState({ showToast: false, toastType: 'success', toastMessage: "" })
    const formRef = useRef(null);

    useEffect(() => {
        if (alert?.length > 0) {
            setShowToast(prev => ({ ...prev, showToast: true, toastType: alert[0][0], toastMessage: alert[0][1] }))
        }
    }, [alert])

    const submitForm = (e) => {
        e?.preventDefault?.();
        formRef.current?.requestSubmit();
    };

    return (
        <div className={styles.wrapper}>
            <ToastNotification
                showToast={showToast}
                setShowToast={setShowToast}
            />
            <form
                ref={formRef}
                className={styles.formWrapper}
                action={pathname}
                method="POST"
                name="codeForm"
                target="_self"
                autoComplete="off"
            >
                <input type="hidden" value={csrfToken()} name="authenticity_token" />
                <h2>You are invited</h2>
                <p>Enter your invitation code here to continue.</p>
                <input
                    type="password"
                    name="invitation_code"
                    aria-label="invitation_code"
                    autoComplete="off"
                    onKeyDown={(e) => {
                        if (e.key === "Enter") submitForm(e);
                    }}
                />
                <Button
                    text={'Continue'}
                    classList={'success'}
                    addonClass={'text-center'}
                    type={'submit'}
                    onClick={submitForm}
                />
            </form>
        </div>
    )
}
export default PasswordProtectedKDF;